module.exports = __webpack_public_path__ + "static/media/social-manage.ca068b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-manage.png
// module id = 72
// module chunks = 0